import { useState } from 'react'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { StaticSummary } from '../StaticSummary/StaticSummary'
import { SummaryS } from '../StaticSummary/SummaryS'
import { Icon } from '../StaticSummary/Icon'
import { ContentSwitcherBySkin } from 'components/Atoms/ContentSwitcherBySkin'
import { SKINS } from 'constants/skins'
import { WsbStaticLeftContent } from './WsbStaticContent'

const STATIC_CONTENT_BY_SKIN = {
  [SKINS.WSB]: <WsbStaticLeftContent />,
  [SKINS.DEFAULT]: null,
}

export const StaticLeftPanelSection = () => {
  const { isOpenLeftPanel } = useLayoutV3State()
  const [hideSection, setHideSection] = useState(false)

  if (hideSection) return null
  return (
    <StaticSummary isOpen={isOpenLeftPanel}>
      {/* <SummaryS>
        <h1>
          <Icon />
          ANNOUNCEMENTS
        </h1>
      </SummaryS> */}
      <ContentSwitcherBySkin
        noWrapper
        onChildrenNull={(isNull) => setHideSection(isNull)}
        componentsBySkin={STATIC_CONTENT_BY_SKIN}
      />
    </StaticSummary>
  )
}
